var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-container"},[_c('chat-toolbar'),_c('chat-body',{ref:"chatBody"}),_c('chat-action'),_c('chat-message-image-dialog',{ref:"imageDialog"}),(!_vm.currentChatId)?_c('div',{staticClass:"disable-overlap"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }